var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"label-wrapper",class:{
    default: _vm.isDefault,
    holiday: _vm.isHoliday,
    empty: _vm.isEmpty},style:({ 
    width: _vm.width+'px',
    height: _vm.height+'px',
    borderRadius: _vm.bRadius+'px'})},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []

export { render, staticRenderFns }